import { openDB } from 'idb';

const DB_NAME = 'MyShoppingWeb';
const DB_VERSION = 1;
const TOKEN_STORE_NAME = 'MyShoppingWebDB';

export const SaveTokenInIndexedDB = async (value: any, key: string) => {
  try {
    const dbExists = await checkIfDBExists(DB_NAME);

    if (dbExists) {
      await updateDatabase(value, key);
    } else {
      await createDatabase(value, key);
    }
  } catch (error: any) {
    alert(`Error saving token in IndexedDB: ${error}`);
  }
};

async function checkIfDBExists(dbName: string): Promise<boolean> {
  const dbNames = await window.indexedDB.databases();
  return dbNames.some((db) => db.name === dbName);
}

async function updateDatabase(value: any, key: string) {
  try {
    const db = await openDB(DB_NAME, DB_VERSION);

    const tx = db.transaction(TOKEN_STORE_NAME, 'readwrite');
    const store = tx.objectStore(TOKEN_STORE_NAME);
    await store.put(value, key);
    await tx.done;

    db.close();
  } catch (error) {
    console.error('Error updating database:', error);
  }
}

async function createDatabase(value: any, key: string) {
  try {
    const db = await openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(TOKEN_STORE_NAME)) {
          db.createObjectStore(TOKEN_STORE_NAME);
        }
      },
    });

    const tx = db.transaction(TOKEN_STORE_NAME, 'readwrite');
    const store = tx.objectStore(TOKEN_STORE_NAME);
    await store.put(value, key);
    await tx.done;

    db.close();
  } catch (error) {
    console.error('Error creating database:', error);
  }
}
